import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from './admin/api.service';

@Injectable({
  providedIn: 'root'
})
export class CommonapiService {

  constructor(private apiservice : ApiService) { }

  private dataCountry = new BehaviorSubject(null)
  countrydata$ = this.dataCountry.asObservable();

  private serviceCitySubject = new BehaviorSubject(null)
  serviceCity$ = this.serviceCitySubject.asObservable();

  private currencyData = new BehaviorSubject(null)
  currency$ = this.currencyData.asObservable();

  private vehicleType = new BehaviorSubject(null)
  serviceVehicleType$ = this.vehicleType.asObservable();

  private shuttleVehicleType = new BehaviorSubject(null)
  shuttleServiceVehicleType$ = this.shuttleVehicleType.asObservable();

  private makeSubject = new BehaviorSubject(null);
  makeData$ = this.makeSubject.asObservable();

  private modelSubject = new BehaviorSubject(null);
  modelData$ = this.modelSubject.asObservable();

  private admingroupSubject = new BehaviorSubject(null);
  admingroup$ = this.admingroupSubject.asObservable();

  private langugeSubject = new BehaviorSubject(null)
  language$ = this.langugeSubject.asObservable();

  setAdminGroup(data){
    this.admingroupSubject.next(data)
  }

  setCountryData(data){
    this.dataCountry.next(data)
  }

  setMakeData(data){
    this.makeSubject.next(data)
  }

  setLanguage(data){
    this.langugeSubject.next(data)
  }

  setServiceAvailableCity(data){
    this.serviceCitySubject.next(data)
  }

  setcurreny(data){
    this.currencyData.next(data);
  }

  setVehicleServiceType(data){
    this.vehicleType.next(data)
  }

  setShuttleVehicleServiceType(data){
    this.shuttleVehicleType.next(data)
  }

  setStateData(data){
    return this.apiservice.CommonGetApi('common/list/state/' + data)
  }

  setCityData(countrydata , statedata){
    return this.apiservice.CommonGetApi('common/list/city/' + countrydata + '/' + statedata)
  }

  setModelData(data , payLoad?){
    if (payLoad) {
      return this.apiservice.CommonPutApi(`common/model/${data}`, payLoad);
    } else {
      return this.apiservice.CommonGetApi(`common/model/${data}`);
    }
  }

}
